import baseColumns from './base-columns';

export default function SocialMediaColumns(params: any) {
  const { formatMessage, pageInfo, sort, setSort, history, dispatch } = params;

  const columns = baseColumns(
    [
      {
        key: 'rank',
      },
      'game',
      'platform',
      'genre',
      'mentions',
      'sentiment',
      'emerging_keywords',
      'action',
    ],
    {
      formatMessage,
      pageInfo,
      sort,
      setSort,
      history,
      dispatch,
    },
  );

  return columns;
}
